import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import style from '../../style/components/linkages/WebsitesGrantedAccess.module.scss';
import WebsitesRow from './WebsitesRow';
import PropTypes from 'prop-types';
import LabelSelect from '../LabelSelect';

const WebsitesGrantedAccessTable = ({ accounts }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(accounts[0]);

  const handleSelect = (e) => {
    const id = Number(e.target.value);

    const account = accounts.find((a) => a.id === id);

    setSelected(account);
  };

  return (
    <div>
      <LabelSelect
        name="account"
        label={t('linkage.label_linkedAccounts')}
        placeholder={t('linkage.placeholder_selectAccount')}
        value={selected.id}
        onChange={handleSelect}
        options={accounts.map((a) => ({
          value: a.id,
          label: a.name + ' (' + a.email + ')',
        }))}
        disabled={null}
        noMargin
      />
      <div>
        {selected && (!selected.consents || selected.consents.length === 0) ? (
          <div className={style.body}>
            {t('linkage.description_noConsents')}
          </div>
        ) : (
          <table className={style.table}>
            <thead>
              <tr>
                <th>{t('linkage.heading_websiteName')}</th>
                <th>{t('linkage.heading_authorized')}</th>
                <th>{t('linkage.heading_actions')}</th>
              </tr>
            </thead>
            <tbody>
              {selected.consents.map((site) => (
                <WebsitesRow
                  key={site.id}
                  style={style}
                  site={site}
                  account={selected}
                />
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

WebsitesGrantedAccessTable.propTypes = {
  accounts: PropTypes.arrayOf(PropTypes.shape({})),
};

WebsitesGrantedAccessTable.defaultProps = {
  accounts: [],
};

export default WebsitesGrantedAccessTable;
